
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../Helper/ToastMessage";

// Get Table Data
export const WorkProgressTableDataAPI = createAsyncThunk("WorkProgressTableData", async ({ data }) => {
    const {
        M_WardID,
        M_FinancialYearID,
        M_MonthID,
        M_RM_LocationID,
        M_RM_WorkID,
        M_UsersID,
        token,
        From,
        To,
        Flag,
        handleGetExport
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/APKDashboard/Get_WEB_RM_T_KPI_WorkProgress_Select?M_FinancialYearID=${M_FinancialYearID ? M_FinancialYearID : '0'}&M_MonthID=${M_MonthID ? M_MonthID : '0'}&M_WardID=${M_WardID ? M_WardID : '1'}&M_RM_LocationID=${M_RM_LocationID}&M_RM_WorkID=${M_RM_WorkID}&M_UsersID=${M_UsersID}&Flag=${Flag}&From=${From}&To=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleGetExport && handleGetExport()
                return result.data
            } else {
                return result
            }
        })
})

const WorkProgressTableDataSlice = createSlice({
    name: "WorkProgressTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WorkProgressTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(WorkProgressTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(WorkProgressTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const WorkProgressTableDataReducer = WorkProgressTableDataSlice.reducer

// Get Export Table Data
export const WorkProgressExportTableDataAPI = createAsyncThunk("WorkProgressExportTableData", async ({ data }) => {
    const {
        M_WardID,
        M_FinancialYearID,
        M_MonthID,
        M_RM_LocationID,
        M_RM_WorkID,
        M_UsersID,
        token,
        From,
        To,
        Flag,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/APKDashboard/Get_WEB_RM_T_KPI_WorkProgress_Select?M_FinancialYearID=${M_FinancialYearID ? M_FinancialYearID : '0'}&M_MonthID=${M_MonthID ? M_MonthID : '0'}&M_WardID=${M_WardID ? M_WardID : '1'}&M_RM_LocationID=${M_RM_LocationID}&M_RM_WorkID=${M_RM_WorkID}&M_UsersID=${M_UsersID}&Flag=${Flag}&From=${From}&To=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const WorkProgressExportTableDataSlice = createSlice({
    name: "WorkProgressExportTableData",
    initialState: {
        isExportLoading: false,
        WorkProgressExportTableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WorkProgressExportTableDataAPI.pending, (state, action) => {
            state.isExportLoading = true;
        });
        builder.addCase(WorkProgressExportTableDataAPI.fulfilled, (state, action) => {
            state.isExportLoading = false;
            state.WorkProgressExportTableData = action.payload;
        });
        builder.addCase(WorkProgressExportTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isExportLoading = false;
            state.isError = true;
            state.WorkProgressExportTableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const WorkProgressExportTableDataReducer = WorkProgressExportTableDataSlice.reducer


